'use client';

import clsx from 'clsx';
import type { FC } from 'react';

import type { CheckoutPreOrderSummary } from '@/lib/checkout/preOrderSummary';

import { PreOrderSummaryRows } from '../PreOrderSummaryRows';

export interface PreOrderFooterBreakdownProps {
  summary: CheckoutPreOrderSummary;
  isDepositPaid?: boolean;
  useFinalPaymentLabel?: boolean;
  showSummaryNote?: boolean;
  className?: string;
}

/** Pre-order deposit/balance rows for footers where total is shown separately. */
export const PreOrderFooterBreakdown: FC<PreOrderFooterBreakdownProps> = ({
  summary,
  isDepositPaid = false,
  useFinalPaymentLabel = false,
  showSummaryNote = true,
  className,
}) => (
  <PreOrderSummaryRows
    deposit={{ amount: summary.deposit, currency: summary.currency }}
    balance={{ amount: summary.balance, currency: summary.currency }}
    depositPercentage={summary.depositPercentage}
    isDepositPaid={isDepositPaid}
    useFinalPaymentLabel={useFinalPaymentLabel}
    showTotal={false}
    showSummaryNote={showSummaryNote}
    className={clsx(className)}
  />
);
